/* src/components/dashboard/WeeklyTracker.js */
import React, { useMemo } from 'react';
import { calculateWeeklyActivity, getTodayIndex } from '../../utils/weeklyTrackerUtils';

/**
 * Weekly Tracker Component - Shows which days of the current week the user has completed sessions
 * Displays 7 circular indicators for each day of the week (M T W T F S S)
 * Improved for better mobile display and proper spacing
 */
const WeeklyTracker = ({ sessions }) => {
  // Calculate which days of the current week have sessions
  const weeklyActivity = useMemo(() => calculateWeeklyActivity(sessions), [sessions]);
  
  // Day letters for display
  const dayLetters = ['M', 'T', 'W', 'T', 'F', 'S', 'S'];
  
  // Get today's index in our week display (0 = Monday, 6 = Sunday)
  const todayIndex = getTodayIndex();

  // Generate tooltips for each day
  const getDayName = (index) => {
    const days = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];
    return days[index];
  };
  
  return (
    <div className="grid grid-cols-7 gap-1 w-full">
      {dayLetters.map((day, index) => {
        // Determine if this day is in the past, today, or future
        const isPast = index < todayIndex;
        const isToday = index === todayIndex;
        const isFuture = index > todayIndex;
        const isCompleted = weeklyActivity[index];
        
        return (
          <div key={index} className="flex justify-center">
            <div 
              title={`${getDayName(index)}${isCompleted ? ' - Completed' : ''}${isToday ? ' (Today)' : ''}`}
              className={`
                flex items-center justify-center 
                w-5 h-5 sm:w-6 sm:h-6 rounded-full text-[10px] sm:text-xs font-medium
                transition-all duration-300 hover:scale-105
                ${isCompleted 
                  ? 'bg-indigo-600 text-white' 
                  : 'bg-gray-100 text-gray-500 border border-gray-200'}
                ${isToday && !isCompleted 
                  ? 'ring-1 ring-indigo-200 animate-pulse-fade-slight' 
                  : ''}
                ${isPast && !isCompleted
                  ? 'bg-gray-50 border-gray-100'
                  : ''}
                ${isFuture
                  ? 'bg-gray-50 border-dashed border-gray-200'
                  : ''}
              `}
            >
              {day}
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default WeeklyTracker;